// extracted by mini-css-extract-plugin
export default {"cardElementContainer":"StripeCheckoutForm_cardElementContainer__uWzYx","errorAlert":"StripeCheckoutForm_errorAlert__6GAG4","paymentButton":"StripeCheckoutForm_paymentButton__Oplui"};